import moment from 'moment';

import templateUrl from './employee-work-order-list.component.html'
import { EmployeeService } from '../../../../../core/services';
import { IQService } from 'angular';
import { UtilityService } from '../../../../../core/services/utility.service';

export const EmployeeWorkOrderListComponent = {
    controller: EmployeeWorkOrderListController,
    controllerAs: "vm",
    templateUrl
};

function EmployeeWorkOrderListController($q: IQService, $uibModal, utilityService: UtilityService,
    employeeService: EmployeeService, divisionService,
    productsService, productLinesService, workOrderPayoutService, icdCorporationService) {
    'ngInject';

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.divisions;
    vm.products;
    vm.productLines;
    vm.filters = {};
    vm.filters.StartDate = moment().subtract(1, "months").startOf("day").toDate();
    vm.filters.EndDate = moment().startOf("day").toDate();
    vm.ownerFilters = {};
    vm.workOrders;
    vm.showFilters = true;
    vm.$onInit = onInit;
    // This page contains logic used by Rogers that is not general to all divisions.
    vm.divisionID = divisionService.divisionIDs.Rogers;
    vm.onViewDetails = onViewDetails;
    vm.onRefreshData = onRefreshData;
    vm.onClaimWorkOrders = onClaimWorkOrders;
    vm.onViewWorkOrders = onViewWorkOrders;
    vm.filterWorkOrders = filterWorkOrders;
    vm.filterEmployeeWorkOrders = filterEmployeeWorkOrders;
    function onInit() {

        activate();
    }

    function activate() {
        const identity = employeeService.retrieveIdentity();
        const dataLoaded = $q.all([identity, loadInitialData()])
            .then(([identity, _]) => {
                vm.isOwnerView = identity.Roles.some(role => role === "Owner");
                vm.isSalesRep = !vm.isOwnerView && identity.Roles.some(role => role === "Sales Rep");
                vm.userID = identity.EmployeeID;
                vm.filters.icdCorporation = vm.isOwnerView && !vm.isSalesRep ? vm.icdCorporations[0] : null;
            })
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(dataLoaded, "Initial load failed"));
    }

    function loadInstallSales() {
        return workOrderPayoutService.retrieveWorkOrderRepPayout({
            DivisionID: vm.divisionID,
            OrderStartDate: vm.filters.StartDate,
            OrderEndDate: vm.filters.EndDate,
            ShowLoggedInUserWorkOrders: vm.isSalesRep,
            ShowAllWorkOrders: true,
            IcdCorporationID: vm.isOwnerView && vm.filters.icdCorporation ? vm.filters.icdCorporation.Id : null
        }).then(function (workOrders) {
            vm.workOrders = workOrders.filter(function (workOrder) {
                return workOrder.Employee && workOrder.Employee.EmployeeID === vm.userID;
            });
            workOrders.forEach(hydrateWorkOrder);
            vm.employeeWorkOrders = groupWorkOrdersToEmployee(workOrders)
        });

    }

    function loadInitialData() {


        const getProducts = productsService.retrieveProducts();
        const getProductLines = productLinesService.retrieveProductLines();
        const getDivisions = divisionService.retrieveDivisions();
        const getCorporations = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout");


        return $q.all([getProducts, getProductLines, getDivisions, getCorporations])
            .then(function (v) {
                vm.products = v[0];
                vm.productLines = v[1];
                vm.divisions = v[2];
                vm.divisions = v[2];
                vm.icdCorporations = v[3];

            });
    }


    function onViewDetails(workOrder) {
        $uibModal.open({
            component: "apexEmployeeWorkOrderProductOrdersModal",
            resolve: {
                workOrder: workOrder
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        });
    }

    function onClaimWorkOrders() {
        $uibModal.open({
            component: "apexWorkOrderEmployeeClaimFormModal",
            windowClass: 'xx-dialog pagespinner',
            size: 'sm',
            backdrop: 'static'
        });
    }


    function onViewWorkOrders(employee) {

        $uibModal.open({
            component: "apexEmployeeWorkOrdersListModal",
            resolve: {
                employee: function () {
                    return employee;
                }
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        });
    }

    function onRefreshData() {

        $q.when(utilityService.showLoading())
            .then(loadInstallSales)
            .catch(function (ex) {
                alert(`Load failed: ${utilityService.getExceptionMessage(ex)}`);
            })
            .then(utilityService.hideLoading);

    }

    function hydrateWorkOrder(workOrder) {

        workOrder.WorkOrder.ProductOrders.forEach(function (productOrder) {
            productOrder.Product = vm.products.filter(function (product) {
                return product.ProductID === productOrder.ProductID;
            })[0];
            productOrder.ProductLine = vm.productLines.filter(function (productLine) {
                return productLine.ProductLineID === productOrder.ProductLineID;
            })[0];
            const productPayoutAmount = workOrder.PayoutTotals.ProductPayouts.filter(function (productPayoutTotal) {
                return productPayoutTotal.ProductID === productOrder.ProductID
                    && productPayoutTotal.ProductLineID === productOrder.ProductLineID;
            })[0];
            productOrder.PayoutAmount = productPayoutAmount ? productPayoutAmount.PayoutAmount : 0;
        });
        workOrder.PayoutTotals.ProductPayouts.forEach(function (productOrder) {
            productOrder.Product = vm.products.filter(function (product) {
                return product.ProductID === productOrder.ProductID;
            })[0];
            productOrder.ProductLine = vm.productLines.filter(function (productLine) {
                return productLine.ProductLineID === productOrder.ProductLineID;
            })[0];
        });
        workOrder.PayoutTotals.MultiPlayPayouts.forEach(function (multiPlayLine) {
            multiPlayLine.ProductLine = vm.productLines.filter(function (productLine) {
                return productLine.ProductLineID === multiPlayLine.ProductLineID;
            })[0];
        });
    }

    function groupWorkOrdersToEmployee(workOrders) {
        //Group work orders by employees
        const employeeWorkOrders: any = Object.values(workOrders.reduce(function (workorder, x) {
            if (x.Employee) {
                (workorder[x.Employee.EmployeeID] = workorder[x.Employee.EmployeeID] || []).push(x);
            }
            return workorder;
        }, {}));

        employeeWorkOrders.forEach(function (employeeWorkOrder) {
            employeeWorkOrder.Employee = employeeWorkOrder[0].Employee;
            employeeWorkOrder.IcdOffice = employeeWorkOrder[0].IcdOffice;
            employeeWorkOrder.Payout = employeeWorkOrder.reduce(function (s, a) {
                return s + a.PayoutTotals.GrossPayout;
            }, 0);
            employeeWorkOrder.WorkOrders = employeeWorkOrder;
        });

        return employeeWorkOrders;
    }

    function filterWorkOrders(workOrder) {

        return (!vm.filters.OfficeName || utilityService.containsInvariant(
            workOrder.IcdOffice.OfficeName, vm.filters.OfficeName))
            && (!vm.filters.DivisionWorkOrderID || utilityService.containsInvariant(
                workOrder.WorkOrder.DivisionWorkOrderID, vm.filters.DivisionWorkOrderID))
            && (!vm.filters.OrderDate || moment(vm.filters.OrderDate).isSame(workOrder.WorkOrder.OrderDate))
            && (!vm.filters.ReportDate || moment(vm.filters.ReportDate).isSame(workOrder.WorkOrder.ReportDate))


    }


    function filterEmployeeWorkOrders(employee) {
        return (!vm.ownerFilters.OfficeName || utilityService.containsInvariant(
            employee.IcdOffice.OfficeName, vm.ownerFilters.OfficeName))
            && (!vm.ownerFilters.FirstName || utilityService.containsInvariant(
                employee.Employee.FirstName, vm.ownerFilters.FirstName))
            && (!vm.ownerFilters.LastName || utilityService.containsInvariant(
                employee.Employee.LastName, vm.ownerFilters.LastName))


    }
}
